import { Grid, Link, withStyles } from "@material-ui/core";
import { ErrorRounded } from "@material-ui/icons";
import React, { Component } from "react";
import appConstants from "../../../../../../../appConstants";
import ToolTip from "../../../../../../common/StyledToolTip";
import styles from "./styles";

export class DefectDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMore: false,
    };
  }

  switchShowMore = () => {
    this.setState((prevState) => ({
      showMore: !prevState.showMore,
    }));
  };

  handleShowAll = () => {
    const { openDvirReports } = this.props;

    openDvirReports && openDvirReports();
  };

  getDefectComment = (defect, classes) => {
    return (
      <ToolTip
        title={`Severity: ${
          appConstants.DEFECTS_SEVERITY_CODES[defect.severity]
        }`}
      >
        <div className={classes.section}>
          <ErrorRounded
            className={`${classes.severityIcon} ${
              defect.severity == appConstants.DEFECTS_SEVERITY_TYPES.H
                ? classes.severityHigh
                : classes.severityLow
            }`}
          />
          <span className={`${classes.textStyles} ${classes.comment}`}>
            {defect.comments}
          </span>
        </div>
      </ToolTip>
    );
  };

  render() {
    const { classes, equipmentType } = this.props;
    const { showMore } = this.state;
    const defects = this.props.defects.filter((item) => item.comments);
    const defectsList = showMore ? defects : defects.slice(0, 3);
    return (
      <Grid container>
        <Grid item xs={4} />
        <Grid item xs={8} className={classes.outerContainer}>
          {defectsList.map((defect, index) => (
            <div key={index}>{this.getDefectComment(defect, classes)}</div>
          ))}
          {defects.length > 3 ? (
            <div
              className={`${classes.textStyles} ${classes.showMore}`}
              onClick={this.switchShowMore}
            >
              {showMore ? "Show Less" : "Show More"}
            </div>
          ) : null}

          <Link
            component="button"
            variant="h3"
            className={classes.showAll}
            onClick={this.handleShowAll}
          >
            Show all defected {equipmentType}
          </Link>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(DefectDetails);
